import * as Types from './types';

const updateAndPublish = (postingId, planId, location = {}) => ({
  type: Types.SAVE_STEP_PRESENTATION,
  meta: {
    async: true,
    api: 'publicador',
    path: `/publicador/api/v1/postings/STEP_PRESENTATION`,
    body: {
      postingId,
      publication_plan: planId
    },
    method: 'POST'
  },
  navigateOnSuccess: {
    replace: false,
    location: {
      ...location,
      pathname: '/publicador/status/success'
    }
  },
  navigateOnFail: {
    replace: false,
    location: {
      ...location,
      pathname: '/publicador/status/failed'
    }
  }
});

const getPresentationInfo = postingId => ({
  type: Types.GET_STEP_PRESENTATION,
  meta: {
    async: true,
    api: 'publicador',
    path: `/publicador/api/v1/postings/STEP_PRESENTATION/${postingId}`,
    method: 'GET'
  }
});

export { updateAndPublish, getPresentationInfo };
